import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {IWSPIconProps, WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';

const styles = require('./CellSettingsBarButton.less');
const cx = classnames.bind(styles);

export interface ICellSettingsBarButtonProps
{
    className?:string;
    iconProps?:IWSPIconProps;
    isToggledOn?:boolean;
    isToggledOnClass?:string;
    onClick?:(event:React.MouseEvent<HTMLElement>) => void;
    arrowIcon?:boolean;
    text?:string | number;
}

@observer
export class CellSettingsBarButton extends React.Component<ICellSettingsBarButtonProps, any>
{
    public render():JSX.Element
    {
        const {
            className,
            iconProps,
            isToggledOn,
            isToggledOnClass,
            onClick,
            arrowIcon,
            text,
        } = this.props;

        const customToggledOnClass = isToggledOn && isToggledOnClass ? isToggledOnClass : '';

        return (
            <div
                className={cx('base', {isToggledOn, arrowIcon}, customToggledOnClass, className)}
                onClick={onClick}
            >
                {
                    iconProps &&
                    <WSPIcon
                        size={WSPIconSize.medium20}
                        {...iconProps}
                        className={cx('icon', iconProps && iconProps.className)}
                    />
                }
                {
                    text &&
                    <span className={cx('text')}>{text}</span>
                }
                {this.props.children}
                {
                    arrowIcon &&
                    <MDIcon
                        className={cx('arrowDown')}
                        name={MDIcons.common.ArrowDropdown}
                    />
                }
            </div>
        );
    }
}
